import jamesPic from "@/public/images/artists/james.png";
import { Artist } from "@/types/types";

export const james = {
  id: "29",
  name: "James",
  image: jamesPic,
  description: `With a voice that drips with raw sentiment, James brings a profound depth to the world of pop music. His heartfelt delivery and evocative lyrics resonate with listeners on a soulful level. From tender ballads to anthems of self-discovery, James' emotional vocals create an intimate connection that lingers long after the last note fades.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fjames-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Pop", "Ballads"],
      secondary: ["Singer", "Emotional", "Soulful"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "High",
      },
      specific: {
        low: 49,
        high: 72,
      },
    },
  },
} as const satisfies Artist;
